export const isEventWidgetSoundSettingsShown = state =>
  state.eventsWidgetSoundSettings.shown;
